export let config = {
  title: 'title',
  meta: {
    title: 'title',
    description: 'description',
    og: {
      title: 'title',
      description: 'description'
    }
  },
  analytics: {
    name: 'new-user',
    openSurvey: 'surveys_open',
    sendAnswers: 'surveys_send_answers',
    closeSurvey: 'surveys_close'
  },
  intro: {
    text: 'intro_t',
    btn: 'intro_b',
    cancel: 'b_cancel',
  },
  questions: [
    {
      type: "Close",
      required: true,
      props: {
        question: 'q_1',
        variants: [
          'q_1_v_1',
          'q_1_v_2',
          'q_1_v_3',
          'q_1_v_4',
          'q_1_v_5',
          'q_1_v_6',
          'q_1_v_7',
        ],
        oneAnswer: true,
        lastIsOtherOption: true
      }
    },
    {
      type: "Close",
      required: true,
      props: {
        question: 'q_2',
        variants: [
          'q_2_v_1',
          'q_2_v_2',
          'q_2_v_3',
          'q_2_v_4',
          'q_2_v_5',
        ],
        oneAnswer: true,
        lastIsOtherOption: false
      }
    },
    {
      type: "Close",
      required: true,
      props: {
        question: 'q_3',
        variants: [
          'q_3_v_1',
          'q_3_v_2',
          'q_3_v_3',
          'q_3_v_4',
          'q_3_v_5',
          'q_3_v_6',
          'q_3_v_7',
          'q_3_v_8',
          'q_3_v_9',
        ],
        oneAnswer: true,
        lastIsOtherOption: true
      }
    },
    {
      type: "Close",
      required: true,
      props: {
        question: 'q_4',
        variants: [
          'q_4_v_2',
          'q_4_v_9',
          'q_4_v_1',
          'q_4_v_3',
          'q_4_v_4',
          'q_4_v_5',
          'q_4_v_6',
          'q_4_v_7',
          'q_4_v_8',
          'q_4_v_10',
          'q_4_v_11',
          'q_4_v_12',
          'q_4_v_13',
          'q_4_v_14',
        ],
        oneAnswer: false,
        lastIsOtherOption: true,
      }
    },
    {
      type: "Close",
      required: true,
      props: {
        question: 'q_5',
        variants: [
          'q_5_v_1',
          'q_5_v_2',
          'q_5_v_3',
          'q_5_v_4',
          'q_5_v_5',
        ],
        oneAnswer: true,
        lastIsOtherOption: true,
      }
    },
    {
      type: "Close",
      required: true,
      props: {
        question: 'q_6',
        variants: [
          'q_6_v_2',
          'q_6_v_3',
          'q_6_v_1',
          'q_6_v_4',
          'q_6_v_5',
          'q_6_v_6',
          'q_6_v_7',
          'q_6_v_8',
          'q_6_v_9',
          'q_6_v_10',
        ],
        oneAnswer: false,
        lastIsOtherOption: true,
      }
    },
    {
      type: "Open",
      required: true,
      props: {
        question: 'q_7',
      }
    },
    {
      type: "Open",
      required: false,
      props: {
        question: 'q_8',
        inputLabel: 'q_8_i_l'
      }
    }
  ],
  outro: {
    text: 'outro_t',
    btn: 'outro_b',
    backUrl: 'https://my.findmykids.org'
  },
  btnNext: 'b_next',
  btnBack: 'b_back',
  btnEnd: 'b_end',
  len: {
    all: 7,
    ru: 8,
    en: 8
  } // костыль для показа количества вопросов в зависимости от локали
}